import './App.css';
import UserProfileCard from './Components/Assets/UserProfileCard/UserProfileCard';

function App() {
  return (
    <div className="App">
      <UserProfileCard/>
    </div>
  );
}

export default App;
